import styled from "styled-components";

/** FlowCanvas fills the sidebar column; outer padding lives on
 *  EditAutomationSidebarContentStyles (legacy parity). */
export const StyledFlowCanvasShell = styled.div`
  height: 100%;
  box-sizing: border-box;

  .react-flow {
    width: 100%;
    height: 100%;
  }

  /* Hover preview: highlight the would-be loop source card on the canvas. */
  [data-loop-source-preview="true"] {
    outline: 2px solid var(--solution-primary-color);
    outline-offset: 3px;
    border-radius: 10px;
  }

  /* layout.ts inserts CARD_VGAP between nodes; legacy cards also carry
     margin-bottom: 10px which React Flow includes in measured heights —
     zero the duplicate margin so stack gaps stay ~10px, not ~20px. */
  .react-flow__node,
  .react-flow__node * {
    margin-bottom: 0 !important;
  }
`;
